import { createContext, ReactNode, useEffect, useState } from "react";
import { IFilter, useAnalytics } from "../firebase/firebase";
import { useCooldown } from "./useCooldown";


interface IFilters {
    filters: IFilter[];
    setFilters: (f: IFilter[]) => void;
}

interface FiltersProviderProps {
    children: ReactNode;
}

export const FiltersContext = createContext<IFilters | undefined>(undefined);


export const FiltersProvider = (props: FiltersProviderProps) => {
    const { track } = useAnalytics();
    //'<' | '<=' | '==' | '!=' | '>=' | '>' | 'array-contains' | 'in' | 'array-contains-any' | 'not-in';
    const [filtersValue, setFiltersValue] = useCooldown<IFilter[]>([]);

    return (
        <FiltersContext value={{
            filters: filtersValue,
            setFilters: (filters: IFilter[]) => {
                setFiltersValue(filters);
                track("filters.update", filters);
            },
        }}>
            {props.children}
        </FiltersContext>
    )

}
